var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg3B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(1 0 0 1 0 -987.362121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "path3336-1"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    fill: "#ff0000",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M0.84 1019.74 C0.84 1002.3 15.03 988.13 32.51 988.13 C49.98 988.13 64.17 1002.3 64.17 1019.74 C64.17 1037.18 49.98 1051.35 32.51 1051.35 C15.03 1051.35 0.84 1037.18 0.84 1019.74 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path3338-5"
  }, /*#__PURE__*/React.createElement("path", {
    strokeWidth: 0.14,
    fill: "#ffffff",
    fillRule: "evenodd",
    stroke: "#000000",
    d: "M18.47 1019.41 C18.47 1011.86 24.52 1005.72 31.96 1005.72 C39.41 1005.72 45.46 1011.86 45.46 1019.41 C45.46 1026.96 39.41 1033.1 31.96 1033.1 C24.52 1033.1 18.47 1026.96 18.47 1019.41 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tspan3344-4",
    transform: "matrix(1.009375 0 0 0.990712 24.807872 1006.197998)"
  }, /*#__PURE__*/React.createElement("text", {
    kerning: 0,
    fontFamily: ".AppleSystemUIFont",
    fontWeight: 700,
    fontSize: 22.17
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 21.44
  }, "3"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3B);
export default __webpack_public_path__ + "static/media/3B.dab68bf6594639e1a8ee1d61269dd2d5.svg";
export { ForwardRef as ReactComponent };